export default __webpack_public_path__ + "static/media/Video-Call.705ba351.png";